/**
 * Форматирует название магазина, добавляя <br> перед "пункт приема"
 * @param shopName - название магазина
 * @returns отформатированное название с тегом <br> перед "пункт приема" (если есть)
 */
export const formatShopName = (shopName: string): string => {
	// Проверяем наличие фразы "пункт приема" (без учета регистра)
	const regex = /(Пункт приёма)/gi
	if (regex.test(shopName)) {
		// Заменяем "пункт приема" на "<br>пункт приема"
		return shopName.replace(regex, '<br>$1')
	}

	return shopName
}
